import QRCode from 'qrcode';

const QR_STYLE = {
  width: 256,
  margin: 2,
  color: {
    dark: '#000000',
    light: '#ffffff',
  },
} as const;

/**
 * Generate a QR code data URL for a photo capture session.
 * URL format: {baseUrl}/{lang}/capture/{token}
 */
export async function generateCaptureQR(token: string): Promise<string> {
  const lang = localStorage.getItem('tellowup-language') || 'en';
  const url = `${window.location.origin}/${lang}/capture/${token}`;
  return QRCode.toDataURL(url, QR_STYLE);
}

/**
 * Generate a QR code data URL for an employee invitation.
 * URL format: {baseUrl}/{lang}/join/{code}
 */
export async function generateInviteQR(code: string): Promise<string> {
  const lang = localStorage.getItem('tellowup-language') || 'en';
  const url = `${window.location.origin}/${lang}/join/${code}`;
  return QRCode.toDataURL(url, QR_STYLE);
}

/**
 * Generate a QR code data URL encoding the public order tracking URL.
 * Used by the admin/technician order detail page so the client can scan
 * and subscribe to status updates. The PDF receipt embeds the same QR.
 *
 * URL format: {baseUrl}/{lang}/track?code={releaseCode}
 * Example: https://tellowup.com/es/track?code=TELL-2026-XYZ
 */
export async function generateTrackQR(
  releaseCode: string,
  lang?: string,
): Promise<string> {
  if (!releaseCode) {
    throw new Error('releaseCode is required')
  }
  const resolvedLang = lang || localStorage.getItem('tellowup-language') || 'en';
  const url = `${window.location.origin}/${resolvedLang}/track?code=${encodeURIComponent(releaseCode)}`;
  return QRCode.toDataURL(url, QR_STYLE);
}